import { render } from "./ValidationFormErrors.vue?vue&type=template&id=1172e1cc&ts=true"
import script from "./ValidationFormErrors.vue?vue&type=script&lang=ts"
export * from "./ValidationFormErrors.vue?vue&type=script&lang=ts"

import "./ValidationFormErrors.vue?vue&type=style&index=0&id=1172e1cc&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__